// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__ux4Es","ltr":"Card_ltr__PAnOq","Content":"Card_Content__3cGLz","icon":"Card_icon__3TXJ6"};